<template>
  <div class="business">
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <div>
      
        <!-- Data Table -->
        <!-- <div class="datatable-outer-container"> 
            <data-table
             :columns="exemptTableColumns"
             :tableData="DeductionSection16A"
             :showinrow="true"
             :withForm="false"
             :showhistory="false"
             :showdelete="false"
             :showedit="false"
            >
              <template v-slot:rowcontent="slotprops">
                <div>
                  <p
                    v-if="slotprops.value.column.key == 'particulars'"
                    >{{slotprops.value.record.particulars}}
                  </p>
                  <p
                    v-if="slotprops.value.column.key == 'amount'"
                    >{{slotprops.value.record.amount}}
                  </p>
                </div>
              </template>
            </data-table>
        </div>  -->
        <!-- End -->



      <!-- Table -->
        <div class="datatable-outer-container">
            <div class="datatable-main">
                <table class="datatable">
                  <thead>
                    <tr class="header-row">
                      <th>Particulars</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tr class="record-row">
                    <td class="row-item">
                      Standard Deductions
                    </td>
                    <td class="row-item">
                      ₹ {{ section16A.Section16.stdDeduction}}
                    </td>
                  </tr>
                  <tr class="record-row">
                    <td class="row-item">
                      PT Amount
                    </td>
                    <td class="row-item">
                      ₹ {{this.section16A.Section16.ptAMT}}
                    </td>
                  </tr>
                </table>
              </div>
        </div>
        <!-- End -->
        
      <!-- <pop-up-message
        v-if="showSuccessMsg"
        :message="`Components successfully added`"
        btnText="Back To Assign Fixed Non CTC Components "
        @back="close"
      ></pop-up-message> -->

      <footer>
        <popup-bottom-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Back" type="secondary" @click="goBack"/>
            </btn-grp>
          </template>
        </popup-bottom-container>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import {
  get_axios_file_instance,
  api_variables,
} from "@/apis/variables.js"; 

export default {
  name: "deductionUnderSectionSixteen",
  props: {
    section16A:{
      type:Object
    }
  },
  data() {
    return {
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
      stateList: [],
      DeductionSection16A: [],
       exemptTableColumns: [
        {
          label: "Particulars",
          key: "particulars"
        },
        {
          label: "Amount",
          key: "amount"
        },
      ],
    };
  },
  computed: {
   ...mapState({
     // incomeTaxData: state => state.onboard.statutoryinfo.incometax.data,
      globalData: state => state.globalapi.globalData.data
    }),
   
   
   le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    },
  },

  mounted() {
    this.showSuccessMsg = false;
    this.load();
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    this.showSuccessMsg = false;
  },

  methods: {
    setGolbalData() {
      try {
       
        this.stateList = this.globalData
          ? this.globalData.State
            ? this.globalData.State
            : []
          : [];
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    
      load(){
        this.setGolbalData();
        ////console.log("data check Section 16 A...............",this.section16A);
        let data=this.section16A;
        ////console.log("Section 16 A data", data);
        
        if(this.section16A.Section16.length > 0) {
          this.DeductionSection16A.push({
          particulars: 'Standard Deductions',
          amount: this.section16A.Section16[0]['stdDeduction']
        })

        this.DeductionSection16A.push({
          particulars: 'PT Amount',
          amount: this.section16A.Section16[0]['ptAMT']
        })
        }

        ////console.log(this.DeductionSection16A)

      },

      // Add here code for cancel button to hide popup By Bhushan 
    goBack() {
      this.$emit('back');
    }
      
  },
};
</script>

<style lang="scss" scoped>

// .business {
//   width: 100%;
//   height: 100%;
// }

// .business .top-bar {
//   height: auto;
//   padding: 20px;
//   background-color: #34c0be;
//   display: flex;
// }


.section-table {
  padding: 24px 0px;
}

.datatable-outer-container {
  width: 100%;
}
        
.datatable-outer-container table.datatable {
            width: 100%;
            border-collapse: collapse;
            margin: 0 auto;
            font-family: Montserrat;
            margin-bottom: 4px;
}
        
        .datatable-outer-container table.datatable .header-row {
            background-color: white;
            height: 54px;
        }
        
        .datatable-outer-container table.datatable .header-row th {
            background-color: #f0f1f5;
            border-bottom: 1px solid #34c0be;
            padding: 6px 20px;
        }
        
        .datatable-outer-container table.datatable .header-row th .tl-checkbox {
            text-align: center;
        }
        
        .datatable-outer-container table.datatable .inactiveCols {
            opacity: 0.03;
            background-color: #a2a1a1;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader {
            background-color: #ffffff;
            -webkit-box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
            box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th {
            padding: 0 8px;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th span {
            border-right: 1px solid #ececec;
            padding: 0px 18px 0px 15px;
            display: inline-block;
            vertical-align: middle;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th span:first-child {
            padding: 10px 10px 7px 10px;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type {
            text-align: right;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span {
            border-right: none;
            font-weight: 400;
            font-style: italic;
            position: relative;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span i {
            position: absolute;
            right: 10px;
            top: 2px;
        }
        
        .datatable-outer-container table.datatable .record-row {
            height: 54px;
            border-bottom: 1px solid #d8d8d8;
        }
        
        .datatable-outer-container table.datatable .record-row:nth-child(odd) {
            background-color: #f5f6fa;
        }
        
        .datatable-outer-container table.datatable .record-row.selectedRecord {
            background-color: #E9F9F8;
            opacity: 0.9;
        }
        
        .datatable-outer-container table.datatable .record-row td {
            padding: 6px 8px;
            color: #646464;
            font-weight: 500;
        }
        
        .datatable-outer-container table.datatable .record-row td .tl-checkbox {
            text-align: center;
        }
        
        .datatable-outer-container table.datatable .record-row .actions {
            width: 10%;
            padding: 10px;
        }
        
        .datatable-outer-container table.datatable .record-row .row-item {
            padding: 6px 20px;
        }
        
        .datatable-outer-container table.datatable .record-row .row-item p {
            width: 100%;
            margin-bottom: 0px;
        }
        
        .datatable-outer-container table.datatable .record-row .action-img {
            display: inline-block;
            cursor: pointer;
            opacity: 0;
        }
        
        .datatable-outer-container table.datatable .record-row:hover .action-img {
            opacity: 1;
        }

</style>
